import { useCallback, useState } from "react";

export const useManageModal = (
  defaultState: boolean = false,
): [boolean, { handleOpen: () => void; handleClose: () => void }] => {
  const [open, setOpen] = useState(defaultState);

  const handleOpen = useCallback(() => {
    setOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  return [open, { handleClose, handleOpen }];
};
